import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Grid, Radio, Row, Spin } from 'antd';
import * as Api from 'api';
import ForecastPredictionChart from 'components/activity/ForecastPredictionChart';
import PredictionFilter from 'components/activity/PredictionFilter';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useApi from 'redux/api/api.hook';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const PredictionPage = () => {
  const { showLeftFilter, setShowLeftFilter } = useApi();
  const { md, lg, xl, xxl } = useBreakpoint();
  const [loading, setLoading] = useState(false);

  const [forecastData, setForecastdata] = useState<any[]>([]);

  const loadData = (new_filters) => {
    setLoading(true);

    Api.FORECAST_PREDICT({ camera_id: new_filters.camera_id, category: new_filters.category, startDate: new_filters.startDate, endDate: new_filters.endDate, dateKind: new_filters.dateKind, tag: new_filters.tag, params: new_filters.params_for_api }).then(((res: any) => {
      const data = JSON.parse(res.text);
      setLoading(false);
      setForecastdata(data.data);
      // api update need for no response weather api
      // if (data.success == false) {
      //   notification.open({
      //     message: data.error.info,
      //   });
      //   setForecastdata([]);
      // } else {
      //   setForecastdata(data.data);
      // }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const handleRightFilter = (willShow) => {
    setShowLeftFilter(willShow);
  };

  return (
    <>
      <Row>
        {md && (
          <Col md={6} xxl={4}>
            <div className={classes.imageFilter}>
              <PredictionFilter
                onPredit={(arg) => loadData(arg)}
              />
            </div>
          </Col>
        )}
        {md == false && (
          <Drawer
            title="Filter"
            width={300}
            onClose={() => handleRightFilter(false)}
            visible={showLeftFilter}
            zIndex={900}
            handler={
              (
                <div className={classes.drawerHandle}>
                  {
                    showLeftFilter ? <CloseOutlined onClick={() => handleRightFilter(false)} /> : <FilterOutlined onClick={() => handleRightFilter(true)} />
                  }
                </div>
              )
            }
          >
            <PredictionFilter
              onPredit={(arg) => loadData(arg)}
            />
          </Drawer>
        )}
        <Col md={18} xs={24} xxl={20}>
          <Spin spinning={loading} size="large" wrapperClassName={classes.content}>
            <Row>
              {forecastData.map((e, i) => (
                <Col key={i} md={12}>
                  <ForecastPredictionChart record={e} index={i} />
                </Col>
              ))}
            </Row>
          </Spin>
        </Col>
      </Row>
    </>
  );
};

export default PredictionPage;
